import Breadcrumb from '../../components/common/Breadcrumb'
import styled from '@emotion/styled'
import MaternityForm from './MaternityForm'
import { useRouter } from '../../utils/helper'
import { useGetMaternityById } from '../../services/maternity/maternity-query'
import MaternityInfo from './MaternityInfo'
import Loading from '../../components/common/Loading'
import { maternity, maternityDetail, enrollment, home } from '../../constant/path'
import { mobile, useScreen } from '../../utils/responsive-helper'
import { useMemo } from 'react'
import Headbar from '../../components/common/HeadBar'
import * as paths from '../../constant/path'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux-store'
import { MaternityInfoWithConcentDate, MaternityInfoWithoutConcentDate } from '../../redux-store/maternity-reducer'
import color from '../../constant/colors'

const BackgroundHeader = styled.div`
  background-color: ${color.CHOICES_PRIMARY};
  width: calc(100% - 32px);
  height: 266px;
  margin-top: 0px !important;
  position: absolute;

  ${mobile} {
    width: 100%;
  }
`
const Layout = styled.div`
  width: 768px;
  margin: 0 auto;
  z-index: 1;
  > * {
    margin-top: 24px;
  }

  ${mobile} {
    width: 100%;
  }
`

const MaternityDetail = () => {
  const { query } = useRouter<{ maternityId: number, claimTypeId: string, isCreateNew: 'true' | 'false' }>()

  const { isMobile } = useScreen()
  const { data: maternityItem, isLoading } = useGetMaternityById({ claimId: query.maternityId })
  const initialValue = useMemo(() => { return { relativeTypeId: 0, } }, [])
  const maternityFormValue = useSelector((state: RootState) => state.maternity.claimInfo) as MaternityInfoWithConcentDate & MaternityInfoWithoutConcentDate

  const isCreateNew = useMemo(() => {
    return query.isCreateNew === 'true'
  }, [query.isCreateNew])

  return (
    <Loading loading={false}>
      <BackgroundHeader />
      <Layout>
        <Headbar title={maternityItem?.name || ''} backWard={paths.maternity()} />
        {/* <MaternityInfo maternityItem={maternityItem} /> */}

        {/*   <MaternityDocument /> */}

        <MaternityForm maternityItem={maternityItem} maternityFormValue={maternityFormValue} allpayStatus={false} maternityId={query.maternityId} isCreateNew={isCreateNew} />
      </Layout>
    </Loading>
  )
}

export default MaternityDetail
